import { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ContractorPanel from '../components/ContractorPanel';
import VendorPanel from '../components/VendorPanel';
import ClientPanel from '../components/ClientPanel';
import ARInvoicePanel from '../components/ARInvoicePanel';
import APInvoicePanel from '../components/APInvoicePanel';
import PurchaseOrderPanel from '../components/PurchaseOrderPanel';
import OutgoingWOPanel from '../components/OutgoingWOPanel';
import WorkOrderPanel from '../components/WorkOrderPanel';

const EntityDrawerContext = createContext(null);

export function EntityDrawerProvider({ children }) {
  const [stack, setStack] = useState([]);
  const navigate = useNavigate();

  const openEntity = useCallback((type, id, opts = {}) => {
    const panelTypes = ['contractor', 'vendor', 'client', 'ar_invoice', 'ap_invoice', 'purchase_order', 'outgoing_wo', 'work_order'];
    if (panelTypes.includes(type) && id) {
      setStack(s => [...s, { type, id, opts }]);
    } else {
      const routes = {
        purchase_order: `/purchase-orders/${id}`,
      };
      if (routes[type]) navigate(routes[type]);
    }
  }, [navigate]);

  const closeTop = useCallback(() => {
    setStack(s => s.slice(0, -1));
  }, []);

  const closeAll = useCallback(() => setStack([]), []);

  const current = stack[stack.length - 1];

  return (
    <EntityDrawerContext.Provider value={{ openEntity, closeAll }}>
      {children}
      {current && (
        <>
          {current.type === 'contractor' && (
            <ContractorPanel contractorId={current.id} onClose={closeTop} />
          )}
          {current.type === 'vendor' && (
            <VendorPanel vendorId={current.id} onClose={closeTop} />
          )}
          {current.type === 'client' && (
            <ClientPanel clientId={current.id} onClose={closeTop} />
          )}
          {current.type === 'ar_invoice' && (
            <ARInvoicePanel invoiceId={current.id} onClose={closeTop} />
          )}
          {current.type === 'ap_invoice' && (
            <APInvoicePanel invoiceId={current.id} onClose={closeTop} />
          )}
          {current.type === 'purchase_order' && (
            <PurchaseOrderPanel poId={current.id} onClose={closeTop} />
          )}
          {current.type === 'outgoing_wo' && (
            <OutgoingWOPanel woId={current.id} onClose={closeTop} />
          )}
          {current.type === 'work_order' && (
            <WorkOrderPanel woId={current.id} onClose={closeTop} />
          )}
        </>
      )}
    </EntityDrawerContext.Provider>
  );
}

export function useEntityDrawer() {
  const ctx = useContext(EntityDrawerContext);
  if (!ctx) throw new Error('useEntityDrawer must be used within EntityDrawerProvider');
  return ctx;
}
